import { ApiNewsObject } from './newsModels';
// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

interface AddNews { type: 'ADD_NEWS'; data: ApiNewsObject[]; }
interface AddNewsInternal { type: 'ADD_NEWS_INTERNAL'; data: ApiNewsObject[]; }
interface SetLoading { type: 'SET_LOADING_NEWS'; data: boolean; }
interface SetLoadingInternal { type: 'SET_LOADING_NEWS_INTERNAL'; data: boolean; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction =
      AddNews | SetLoading | AddNewsInternal | SetLoadingInternal
    ;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const newsActionCreators = {
    addNews: (news: ApiNewsObject[]) => <AddNews> { type: 'ADD_NEWS', data: news },
    addNewsInternal: (news: ApiNewsObject[]) => <AddNewsInternal> { type: 'ADD_NEWS_INTERNAL', data: news },    
    setLoading: (data: boolean) => <SetLoading> { type: 'SET_LOADING_NEWS', data: data },
    setLoadingInternal: (data: boolean) => <SetLoadingInternal> { type: 'SET_LOADING_NEWS_INTERNAL', data: data } 
};


// WEBPACK FOOTER //
// ./src/data/news/newsActions.ts